<template>
  <v-app>
    <v-main>
      <router-view :key="$route.fullPath" />
      <BaseErrorDialog />
    </v-main>
  </v-app>
</template>

<script>
import BaseErrorDialog from "@/components/dialogs/BaseErrorDialog";

export default {
  name: "App",
  components: {
    BaseErrorDialog
  },
  created() {
    this.$store.dispatch("AuthorizationStore/getUserInfo");
  }
};
</script>

<style lang="scss">
@import "scss/main";
</style>
